module.exports = __webpack_public_path__ + "media/flags/fr-73f91b4e.png";